import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";

async function getHistoryList(search, pageable) {
    console.log(">> 이력관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        console.log( await needAuth.post('/history?'+pageStr,search))
        return  await needAuth.post('/history?'+pageStr,search);
    }catch (error){
        return error;
    }
}

async function getMemoHistoryList(search, pageable) {
    console.log(">> 메모이력관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/history/memo?'+pageStr,search);
    }catch (error){
        return error;
    }
}

async function getHistoryMenus() {
    return await needAuth.get('/history/menus');
}

export {getHistoryList, getMemoHistoryList, getHistoryMenus};